import React from 'react'

import useStyles from './styles'

type NoGroupsProps = {
  title?: string
}

const NoGroups: React.FC<NoGroupsProps> = ({ title = 'groups' }) => {
  const classes = useStyles()

  return <div className={classes.root}>No {title} for this type</div>
}

export default NoGroups
